<template>
  <div class="tag-detail">
    <!-- 顶部导航 -->
    <div class="detail-header">
      <div class="back-btn" @click="onBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <h3 class="header-title">{{ tagName }} ({{ members.length }})</h3>
      <el-dropdown trigger="click" @command="onDropdownCommand">
        <span class="more-btn">
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="editName">
            <i class="el-icon-edit"></i>
            更改标签名称
          </el-dropdown-item>
          <el-dropdown-item command="delete" divided>
            <i class="el-icon-delete" style="color: #f56c6c;"></i>
            删除标签
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 添加员工 -->
    <div class="section">
      <div class="section-title">
        <span>添加员工</span>
      </div>
      <div class="add-btn-large" @click="onAddMember">
        <i class="el-icon-plus"></i>
        <span>添加员工</span>
      </div>
    </div>

    <!-- 标签内员工 -->
    <div class="section">
      <div class="section-title">
        <span>标签内员工</span>
      </div>
      
      <div v-if="members.length === 0" class="empty-state">
        <i class="el-icon-user"></i>
        <span>暂无员工</span>
      </div>
      
      <div v-else class="member-list">
        <div v-for="member in members" :key="member.id" class="member-item">
          <head-image 
            :name="member.showNickName || member.nickName" 
            :url="member.headImage" 
            :size="44"
          ></head-image>
          <div class="member-info">
            <div class="member-name">{{ member.showNickName || member.nickName }}</div>
            <div class="member-company">{{ member.companyName || '' }}</div>
          </div>
          <el-button type="text" size="small" class="remove-btn" @click="onRemoveMember(member)">
            移除
          </el-button>
        </div>
      </div>
    </div>

    <!-- 添加员工选择弹窗 -->
    <el-dialog
      title="添加员工"
      :visible.sync="selectDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="select-container">
        <!-- 搜索框 -->
        <div class="search-box">
          <el-input
            v-model="searchKey"
            placeholder="搜索员工"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        
        <!-- 好友列表 -->
        <div class="friend-list" v-if="filteredFriends.length > 0">
          <div 
            v-for="friend in filteredFriends" 
            :key="friend.id" 
            class="friend-item"
            :class="{ selected: isSelected(friend) }"
            @click="onToggleSelect(friend)"
          >
            <el-checkbox :value="isSelected(friend)" @change="() => onToggleSelect(friend)"></el-checkbox>
            <head-image 
              :name="friend.showNickName || friend.nickName" 
              :url="friend.headImage" 
              :size="40"
            ></head-image>
            <div class="friend-info">
              <div class="friend-name">{{ friend.showNickName || friend.nickName }}</div>
              <div class="friend-company">{{ friend.companyName || '' }}</div>
            </div>
          </div>
        </div>
        
        <div v-else class="empty-friends">
          <span>{{ searchKey ? '未找到匹配的员工' : '暂无可添加的员工' }}</span>
        </div>
      </div>
      
      <div class="select-footer">
        <span class="selected-count">已选择 {{ selectedIds.length }} 人</span>
        <el-button type="primary" :disabled="selectedIds.length === 0" @click="onConfirmAdd" :loading="loading">
          确定添加
        </el-button>
      </div>
    </el-dialog>

    <!-- 修改名称弹窗 -->
    <el-dialog
      title="更改标签名称"
      :visible.sync="editNameDialogVisible"
      width="400px"
    >
      <el-form :model="nameForm" ref="nameFormRef">
        <el-form-item>
          <el-input
            v-model="nameForm.name"
            placeholder="请输入标签名称"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editNameDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmEditName" :loading="loading">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="确认删除"
      :visible.sync="deleteDialogVisible"
      width="360px"
    >
      <div class="delete-content">
        <i class="el-icon-warning"></i>
        <span>确定删除标签 "{{ tagName }}" 吗？</span>
      </div>
      <span slot="footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="onConfirmDelete" :loading="loading">删 除</el-button>
      </span>
    </el-dialog>

    <!-- 移除成员确认弹窗 -->
    <el-dialog
      title="确认移除"
      :visible.sync="removeDialogVisible"
      width="360px"
    >
      <div class="delete-content">
        <i class="el-icon-warning"></i>
        <span>确定将 "{{ removeMemberName }}" 从标签中移除吗？</span>
      </div>
      <span slot="footer">
        <el-button @click="removeDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="onConfirmRemove" :loading="loading">移 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "TagDetail",
  components: {
    HeadImage
  },
  data() {
    return {
      isLoaded: false,
      tagId: null,
      tagName: '',
      members: [],
      memberIds: [],
      friends: [],
      searchKey: '',
      selectedIds: [],
      
      selectDialogVisible: false,
      editNameDialogVisible: false,
      deleteDialogVisible: false,
      removeDialogVisible: false,
      removeMemberId: null,
      removeMemberName: '',
      
      nameForm: {
        name: ''
      },
      
      loading: false
    }
  },
  computed: {
    filteredFriends() {
      if (!this.searchKey) {
        return this.friends;
      }
      const key = this.searchKey.toLowerCase();
      return this.friends.filter(f => {
        const name = (f.showNickName || f.nickName || '').toLowerCase();
        const company = (f.companyName || '').toLowerCase();
        return name.includes(key) || company.includes(key);
      });
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 初始不需要加载，等外部触发
    },
    loadTag(tagId, tagName) {
      this.tagId = tagId;
      this.tagName = tagName || '标签';
      this.loadTagDetail();
    },
    loadTagDetail() {
      this.$http({
        url: `/friend/tag/detail/${this.tagId}`,
        method: 'get'
      }).then(data => {
        this.members = data.members || [];
        this.memberIds = data.memberIds || [];
        if (data.name) {
          this.tagName = data.name;
        }
      }).catch(() => {
        this.$message.error('加载标签详情失败');
      });
    },
    loadFriends() {
      this.$http({
        url: `/friend/list/excludeTag/${this.tagId}`,
        method: 'get'
      }).then(data => {
        const seen = new Set();
        this.friends = (data || []).filter(f => {
          if (seen.has(f.id)) return false;
          seen.add(f.id);
          return true;
        });
      }).catch(() => {
        this.$message.error('加载好友列表失败');
      });
    },
    isSelected(friend) {
      return this.selectedIds.includes(friend.id);
    },
    onToggleSelect(friend) {
      const idx = this.selectedIds.indexOf(friend.id);
      if (idx > -1) {
        this.selectedIds.splice(idx, 1);
      } else {
        this.selectedIds.push(friend.id);
      }
    },
    onBack() {
      this.$emit('back');
    },
    onDropdownCommand(command) {
      if (command === 'editName') {
        this.onEditTagName();
      } else if (command === 'delete') {
        this.onDeleteTag();
      }
    },
    onEditTagName() {
      this.nameForm.name = this.tagName;
      this.editNameDialogVisible = true;
    },
    onConfirmEditName() {
      if (!this.nameForm.name || !this.nameForm.name.trim()) {
        this.$message.warning('标签名称不能为空');
        return;
      }
      
      this.loading = true;
      this.$http({
        url: '/friend/tag/update',
        method: 'put',
        data: { id: this.tagId, name: this.nameForm.name.trim() }
      }).then(() => {
        this.$message.success('修改成功');
        this.tagName = this.nameForm.name.trim();
        this.editNameDialogVisible = false;
      }).catch(() => {
        this.$message.error('修改失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    onDeleteTag() {
      this.deleteDialogVisible = true;
    },
    onConfirmDelete() {
      this.loading = true;
      this.$http({
        url: `/friend/tag/delete/${this.tagId}`,
        method: 'delete'
      }).then(() => {
        this.$message.success('已删除');
        this.deleteDialogVisible = false;
        this.$emit('back');
      }).catch(() => {
        this.$message.error('删除失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    onAddMember() {
      this.selectedIds = [];
      this.searchKey = '';
      this.loadFriends();
      this.selectDialogVisible = true;
    },
    onConfirmAdd() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请选择要添加的员工');
        return;
      }
      
      this.loading = true;
      this.$http({
        url: `/friend/tag/addMembers/${this.tagId}`,
        method: 'post',
        data: this.selectedIds
      }).then(() => {
        this.$message.success('添加成功');
        this.selectDialogVisible = false;
        this.loadTagDetail();
      }).catch(() => {
        this.$message.error('添加失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    onRemoveMember(member) {
      this.removeMemberId = member.friendId;
      this.removeMemberName = member.showNickName || member.nickName;
      this.removeDialogVisible = true;
    },
    onConfirmRemove() {
      if (!this.removeMemberId) return;
      
      this.loading = true;
      this.$http({
        url: `/friend/tag/removeMembers/${this.tagId}`,
        method: 'post',
        data: [this.removeMemberId]
      }).then(() => {
        this.$message.success('已移除');
        this.removeDialogVisible = false;
        this.removeMemberId = null;
        this.removeMemberName = '';
        this.loadTagDetail();
      }).catch(() => {
        this.$message.error('移除失败');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-detail {
  padding: 15px;
  background: #fafbfc;
  min-height: 400px;

  .detail-header {
    display: flex;
    align-items: center;
    background: white;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;

    .back-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      color: var(--im-color-primary);
      cursor: pointer;
      font-size: 14px;
      
      &:hover {
        opacity: 0.8;
      }
    }

    .header-title {
      flex: 1;
      margin: 0;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    .more-btn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;
      
      &:hover {
        background: #f5f5f5;
      }
    }
  }

  .section {
    background: white;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;

    .section-title {
      font-size: 13px;
      color: #999;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f5f5f5;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    color: #999;
    font-size: 14px;

    i {
      font-size: 48px;
      margin-bottom: 12px;
      color: #ddd;
    }
  }

  .member-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .member-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: 8px;
      transition: background 0.2s;

      &:hover {
        background: #fafafa;
      }

      .member-info {
        flex: 1;
        margin-left: 12px;

        .member-name {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }

        .member-company {
          font-size: 12px;
          color: #999;
          margin-top: 2px;
        }
      }

      .remove-btn {
        color: #f56c6c;
        font-size: 12px;
        padding: 4px 12px;
      }
    }
  }

  .add-btn-large {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px;
    background: #f5f9ff;
    border-radius: 8px;
    color: var(--im-color-primary);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #edf5ff;
    }

    i {
      font-size: 16px;
    }
  }

  .select-container {
    .search-box {
      margin-bottom: 16px;
    }

    .friend-list {
      max-height: 400px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .friend-item {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
          background: #f5f5f5;
        }

        &.selected {
          background: #f0f7ff;
        }

        .el-checkbox {
          margin-right: 12px;
        }

        .friend-info {
          flex: 1;
          margin-left: 12px;

          .friend-name {
            font-size: 14px;
            color: #333;
          }

          .friend-company {
            font-size: 12px;
            color: #999;
            margin-top: 2px;
          }
        }
      }
    }

    .empty-friends {
      text-align: center;
      padding: 40px 0;
      color: #999;
      font-size: 14px;
    }
  }

  .select-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;

    .selected-count {
      font-size: 14px;
      color: #666;
    }
  }

  .delete-content {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;

    i {
      color: #e6a23c;
      font-size: 20px;
    }
  }
}
</style>
